// src/Sections/Niches/index.tsx
import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { niches } from "../../NichePages/data/niches";

const SectionTitle = styled.h2`
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 16px;

  span {
    color: #e4da1b;
  }
`;

const SubTitle = styled.p`
  font-size: 18px;
  font-weight: 300;
  color: #aaa;
  text-align: center;
  margin-bottom: 56px;
`;

const Card = styled.div`
  border: 1px solid #333;
  border-radius: 16px;
  padding: 32px 24px;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.25s ease, transform 0.2s ease;

  &:hover {
    border-color: #e4da1b;
    transform: translateY(-4px);
  }
`;

const CardIcon = styled.div`
  font-size: 40px;
  margin-bottom: 16px;
  color: #e4da1b;
  display: flex;
  justify-content: center;
`;

const CardName = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
`;

const CardTagline = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: #aaa;
  line-height: 20px;
  margin: 0;
`;

const Niches: React.FC = () => {
  const navigate = useNavigate();

  const schedulingNiches = niches.filter((n) => n.module === "scheduling");
  const restaurantNiches = niches.filter((n) => n.module === "restaurant");
  const assistantNiches = niches.filter((n) => n.module === "assistant");

  return (
    <Container
      style={{ paddingTop: "80px", paddingBottom: "80px", background: "#000" }}
      id="section-nichos"
    >
      <SectionTitle>
        O Alfred para o <span>seu negócio</span>
      </SectionTitle>
      <SubTitle>
        Escolha seu segmento e veja como o Alfred trabalha pra você
      </SubTitle>

      {/* Scheduling Group */}
      <SubTitle style={{ marginBottom: "32px", marginTop: "40px", fontSize: "20px", color: "#ccc" }}>
        Negócios com agendamento
      </SubTitle>
      <Row xs="1fr" md="1fr 1fr 1fr" gap="24px" style={{ marginBottom: "60px" }}>
        {schedulingNiches.map((n) => (
          <Card key={n.route} onClick={() => navigate(n.route)}>
            <CardIcon><Icon icon={n.icon} width={40} height={40} /></CardIcon>
            <CardName>{n.name}</CardName>
            <CardTagline>{n.tagline}</CardTagline>
          </Card>
        ))}
      </Row>

      {/* Restaurant Group */}
      <SubTitle style={{ marginBottom: "32px", marginTop: "40px", fontSize: "20px", color: "#ccc" }}>
        Negócios com pedido e delivery
      </SubTitle>
      <Row xs="1fr" md="1fr 1fr 1fr" gap="24px" style={{ marginBottom: "60px" }}>
        {restaurantNiches.map((n) => (
          <Card key={n.route} onClick={() => navigate(n.route)}>
            <CardIcon><Icon icon={n.icon} width={40} height={40} /></CardIcon>
            <CardName>{n.name}</CardName>
            <CardTagline>{n.tagline}</CardTagline>
          </Card>
        ))}
      </Row>

      {/* Assistant Group */}
      <SubTitle style={{ marginBottom: "32px", marginTop: "40px", fontSize: "20px", color: "#ccc" }}>
        Atendimento, vendas e captação
      </SubTitle>
      <Row xs="1fr" md="1fr 1fr 1fr" gap="24px">
        {assistantNiches.map((n) => (
          <Card key={n.route} onClick={() => navigate(n.route)}>
            <CardIcon><Icon icon={n.icon} width={40} height={40} /></CardIcon>
            <CardName>{n.name}</CardName>
            <CardTagline>{n.tagline}</CardTagline>
          </Card>
        ))}
      </Row>
    </Container>
  );
};

export default Niches;
